export default __webpack_public_path__ + "static/urbanClap-7c26ba25b4635f4fe824ca3bba7d3cb6.svg";